import './Header.sass'
import logo from '../../assets/img/logo.png'
import { Link, useLocation, useMatch } from 'react-router-dom'
import { useFormContext } from '../../contexts/formContext'
import { AppBar, Dialog, DialogTitle, IconButton, Toolbar } from '@mui/material'
import { useState } from 'react'
import Form from '../Form/Form'
import CloseIcon from '@mui/icons-material/Close'

export default function Header() {
    const [open, setOpen] = useState(false)
    let { pathname } = useLocation()
    let isHome = useMatch('/showroom')
    const form = useFormContext()

    const handleClose = () => setOpen(false)

    return (
        <header className="header">
            <div className="container">
                <div className="header-block">
                    <Link to={isHome ? '/' : '/showroom/'} className="header-logo">
                        <img src={logo} alt="logo" />
                    </Link>

                    <div onClick={isHome ? () => setOpen(true) : () => form.current.scrollIntoView()} className="header-button">Зарегистрироваться</div>

                    <div className="header-content">
                        <div className="header-open">
                            <strong>Скоро открытие!</strong>
                            <p>г. Санкт-Петербург, ул. Салова, 45 лит. Ф</p>
                        </div>
                        <div className="header-contact">
                            <a href="tel: 8 800 250 79 26">8 800 250 79 26</a>
                            <p>Звонок бесплатный</p>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog onClose={handleClose} open={open} fullScreen>
                <AppBar color='transparent' position='relative'>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            sx={{ml:'auto'}}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Form />
            </Dialog>
        </header>

    )
}